import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { observer } from 'mobx-react'
import { Divider, Form, Grid, Header, Table } from 'semantic-ui-react'
import Section from '../Inputs/Section'
import Input from '../Inputs/Input'
import { runInAction } from 'mobx'
import Checkbox from '../Inputs/Checkbox'
import TableDnD from '../Inputs/TableDnD'
import Select from '../Inputs/Select'
import TextArea from '../Inputs/TextArea'

@observer
class RIA537000P extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  tableList = ['qtyPA']

  handleUpdateRegistryCount = () => {
    const { equipment } = this.props
    let newValue = 0
    for (const name of this.tableList) {
      const fieldValue = parseInt(equipment.getValue(name))
      if (Number.isInteger(fieldValue)) {
        newValue += fieldValue
      }
    }
    runInAction(() => {
      equipment.updateValue('totalEquipment', newValue)
    })
  }

  handleUpdateRegistryFromTableCount = () => {
    const { equipment } = this.props
    const rows = parseInt(equipment.getValue('tableRows', false, 0))
    const countValues = {}
    for (let i = 0; i < rows; i++) {
      const value = equipment.getValue(`dispositif_${i}`)
      if (value) {
        if (countValues[value] === undefined) { countValues[value] = 0 }
        countValues[value]++
      }
    }
    for (const [key, value] of Object.entries(countValues)) {
      runInAction(() => {
        equipment.updateValue(`qty${key}`, value)
      })
    }
    this.handleUpdateRegistryCount()
  }

  render () {
    const { equipment } = this.props
    return (
      <Form>
        <Section title={(<Header as='h2'>VÉRIFICATION SECTORIELLE ÉQUIPEMENTS (CAN/ULC S537)</Header>)}>
          <Form.Group widths='equal'>
            <Input name='modelePanneau' formEntry={equipment} label='Modèle panneau' />
            <Input name='uneDeuxEtapes' formEntry={equipment} label='Une ou deux étapes' />
          </Form.Group>
        </Section>
        <Section title={(<Header as='h2'>REGISTRE DES ÉQUIPEMENTS</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={2}>
                <Header as='h5'>DISPOSITIF</Header>
              </Grid.Column>
              <Grid.Column width={2}>
                <Header as='h5'>DISPOSITIF</Header>
              </Grid.Column>
              <Grid.Column width={10}>
                <Header as='h5'>DESCRIPTION</Header>
              </Grid.Column>
              <Grid.Column width={2}>
                <Header as='h5'>QUANTITÉ</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>PA</Grid.Column>
              <Grid.Column width={2}><Input name='desPA' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={10}>Panneau alarme incendie</Grid.Column>
              <Grid.Column width={2}><Input name='qtyPA' formEntry={equipment} onBlur={this.handleUpdateRegistryCount} size='mini' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={14} verticalAlign='middle'><Header as='h4'>TOTAL</Header></Grid.Column>
              <Grid.Column width={2}><Input name='totalEquipment' formEntry={equipment} size='mini' /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>RAPPORT DE VÉRIFICATION SECTORIELLE (ÉQUIPEMENTS)<br />DU RÉSEAU AVERTISSEUR D'INCENDIE<br />(Normes CAN/ULC-S537)</Header>)}>
          <Input name='designationSystem' formEntry={equipment} label='Désignation du système' />
          <Divider />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Fonctionnement</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportFonctionnementUneEtape' formEntry={equipment} label='Une étape' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportFonctionnementDeuxEtapes' formEntry={equipment} label='Deux étapes' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Communication phonique</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportCommunicationPhoniqueOui' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportCommunicationPhoniqueNon' formEntry={equipment} label='Non' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Système adressable</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemAdressableOui' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemAdressableNon' formEntry={equipment} label='Non' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}><Header as='h5'>Système semi-adressable</Header></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemSemiAdressableOui' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapportSystemSemiAdressableNon' formEntry={equipment} label='Non' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}><Checkbox name='rapportValidation' formEntry={equipment} label='La présente certifie que les équipements incendie ajoutés ont été vérifiés conformément à la norme CAN/ULC-S537, et sont présentement fonctionnels.' /></Grid.Column>
            </Grid.Row>
          </Grid>
          <p>
            <strong>MISE EN GARDE:</strong><br />
            Les essais rapportés dans le présent formulaire ne comprennent pas la mise à l'essai des dispositifs auxiliaires.  Par contre, lors d'une inspection des fonctions auxiliaires, la compagnie PROTECTION INCENDIE MCI inspecte le fonctionnement du relai interne au panneau de contrôle ainsi que la fonction elle-même, dans la mesure du possible lorsqu'elles sont identifiées, mais ne se tient nullement responsable de l'opéation mécanique de ladite fonction auxiliaire.
          </p>
          <p>
            De plus, la validité du certificat n'est pertinente que si aucune autre personne n'altère ou n'additionne des composantes au réseau d'alarme incendie et ce, en tout temps.  Lorsque des modifications sont à effectuer sur ledit réseau, vous devez en aviser le département de service de PROTECTION INCENDIE MCI qui effectuera les vérifications d'usage
          </p>
          <p><strong>IMPORTANT:</strong> Le présent certificat se limite aux équipements apparaissant dans le présent rapport.</p>
          <Divider />
          <TableDnD
            formEntry={equipment}
            tableProps={{ celled: true, compact: 'very', size: 'small', style: { minWidth: '800px!important' } }}
            totalRowLabel='tableRows'
            minimumRows={30}
            addRowLabel="Ajouter X nombre d'équipement supplémentaire"
            droppableKey='tableEquipmentP'
            headers={[{
              props: { style: { width: '30%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'pEmplacement',
              label: 'EMPLACEMENT'
            }, {
              props: { style: { width: '15%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'pModele',
              label: 'MODÈLE'
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'pInstalle',
              label: (<div className='table-vertical'>INSTALLÉ CONVENABLEMENT</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'pManquant',
              label: (<div className='table-vertical'>MISE À LA TERRE</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'pReparation',
              label: (<div className='table-vertical'>RÉPARATION NÉCESSAIRE</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'pFonctionnement',
              label: (<div className='table-vertical'>FONCTIONNEMENT CONFIRMÉ</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'pSupervision',
              label: (<div className='table-vertical'>SUPERVISION CONFIRMÉ</div>)
            }, {
              props: { style: { width: '2%' }, className: 'table-vertical', verticalAlign: 'bottom' },
              key: 'pSurveillance',
              label: (<div className='table-vertical'>SURVEILLANCE DU CÂBLAGE</div>)
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'pDispositif',
              label: 'DISPOSITIF'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'pZone',
              label: 'ZONE OU ADRESSE'
            }, {
              props: { style: { width: '8%' }, textAlign: 'center', verticalAlign: 'bottom' },
              key: 'pDeficiences',
              label: 'DÉFICIENCES ET/OU REMARQUES (VOIR SECTIONS 1-2-3)'
            }
            ]}
            fields={[
              {
                fieldType: Input,
                props: {
                  name: 'emplacement_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'model_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'ic_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'manquant_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rn_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'fc_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'sc_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'sca_'
                }
              }, {
                fieldType: Select,
                props: {
                  name: 'dispositif_',
                  options: [{ value: 'PA', text: 'PA' }],
                  onBlur: this.handleUpdateRegistryFromTableCount,
                  search: true,
                  defaultValue: ''
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'za_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'defRemarque_'
                }
              }
            ]}
          />
        </Section>
        <Section title={(<Header as='h2'>RAPPORT DE VÉRIFICATION DU MATÉRIEL DE CONTRÔLE<br />DOCUMENTATION</Header>)}>
          <Header as='h5'>La documentation du réseau avertisseur est sur place et comporte les descriptions suivantes:</Header>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Instructions pour réarmer le système et interrompre les signaux d'alarme sonores</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Instructions pour interrompre le signal de défectuosité et mesures à prendre quand on entend le signal de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Description de la fonction  de chaque contrôle et indicateur du poste de contrôle d'alerte incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Description du secteur de l'aire ou la zone protégée par chacun des circuits de détection (peut être sous forme de liste ou de plan)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Description du fonctionnement du signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Description du matériel auxiliaire contrôlé par le réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Réseau avertisseur d'incendie connecté pour avertir le service d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
          <p>Si le réseau est connecté, indiquer le poste de surveillance et le nom de la personne qui a confirmé les signaux reçus</p>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={4} textAlign='right'>NO DU POSTE DE SURVEILLANCE</Grid.Column>
              <Grid.Column width={12}><Input name='no_post_surveillance' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4} textAlign='right'>OPÉRATEUR NO. #</Grid.Column>
              <Grid.Column width={12}><Input name='operateur' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4} textAlign='right'>ALARME</Grid.Column>
              <Grid.Column width={12}><Input name='alarme' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4} textAlign='right'>TROUBLE</Grid.Column>
              <Grid.Column width={12}><Input name='trouble' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4} textAlign='right'>SUPERVISION</Grid.Column>
              <Grid.Column width={12}><Input name='supervision' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
          <Header as='h5'>Pour un système qui n'est pas relié à une centrale de surveillance:</Header>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Un avis fixé de façon permanente est installé près de chaque avertisseur manuel, il demande que le service d'incendie soit prévenu, et en indique le numéro de téléphone</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>DISPOSITION ET CIRCUITS CONNEXES - ESSAI ET INSPECTION</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Installation conforme à la conception et à la norme CAN/ULC-S524, Installation des réseaux avertisseurs d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement normal (P. ex. indication d'alarme, de défectuosité, de surveillance et d'annonce)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Enregistrement de zone, de numéro de circuit ou d'adresse</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Enregistrement de l'emplacement des dispositifs classiques</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Enregistrement de la liaison de données, de l'adresse et de l'emplacement des dispositifs actifs et des dispositifs d'appui</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Surveillance du câblage de tous les dispositifs</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Connections correctes aux bornes et section appropriée des fils</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Polarités correctes des circuits</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité en cas de circuit ouvert de dispositif classique</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_q' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité en cas d'enlèvement de dispositif actif et de dispositif d'appui</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_r' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Dans le cas des circuits de classe A, vérification de déconnexion, au point le plus éloigné, du fil de retour au poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_s' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indications de fuite à la terre lorsque le circuit est mis à l'essai à l'endroit du dispositif le plus éloigné</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_t' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>A l'aide d'un appareil de vérification de dispositif, mise à l'essai du dispositif de contact et du dispositif sans contact afin de garantir qu'ils fonctionnent normalement et qu'ils provoquent une annonce au poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_vmc_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_vmc_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_vmc_u' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Intervalle de temps le plus long, entre l'actionnement de 10% des avertisseurs manuels ou de 6 avertisseurs et le déclenchement de l'alarme</Grid.Column>
              <Grid.Column width={6}><Input name='seconds_vmc_v' formEntry={equipment} label='Secondes' /></Grid.Column>
            </Grid.Row>
          </Grid>
          <Header as='h5'>Note: Les résultats des points de cette section ont été consignés sur des formulaiers mulltiples acceptables, ailleurs dans ce document</Header>
        </Section>
        <Section title={(<Header as='h2'>MISE A L'ESSAI DE LA LIAISON DE DONNÉES</Header>)} equipment={equipment} name='mld_so'>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Conditions anormales du réseau, selon le tableau 1 de la norme CAN/ULC-S537</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Conditions d'alarme et de défectuosité reçues au poste de contrôle pendant une fuite à la terre simple sur chaque conducteur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal d'alarme reçu au poste de contrôle des deux côtés d'une fuite à la terre simple</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal d'alarme reçu au poste de contrôle au cours d'une fuite à la terre</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Court-circuit entre deux conducteurs sur une liaison de données à chaque étage, n'empêchant pas la réception de signaux d'alarme et de défectuosité d'une autre zone de la même bouche</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mld_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mld_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mld_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE A L'ESSAI ET INSPECTION DE CIRCUITS TIRANT DE L'ÉNERGIE DU RÉSEAU</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Le dispositif au point le plus éloigné de la source d'énergie (dans chaque circuit) reçoit la puissance nominale prévue dans les spécifications du fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ict_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ict_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ict_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Capacité nominale adéquate des dispositifs de protection contre les surintensités remplaçables</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ict_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ict_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ict_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>INSPECTION DU CÂBLAGE</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Type et section des fils correspondant à ceux du câblage de l'installation du fabricant du matériel a toutes les connexions du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ic_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ic_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ic_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>FICHE D'ESSAI DU POSTE DE CONTRÔLE</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateur visuel</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité visuel commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité sonore commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Interrupteur de signalisation sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité de l'alimentation principale</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fuite à la terre sur signal de défectuosité positif et négatif</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement du signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Passage automatique de signal d'alerte à signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10} />
              <Grid.Column width={6}><Input name='min_fpc_h' formEntry={equipment} label='Minutes' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctinonement du bouton d'aquittement</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Désactivation de l'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement de l'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indication visuelle d'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Déclenchement automatique du signal d'alarme sonore, après interruption, en cas de réception d'alarme subséquente</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Temporisation automatique d'annulation du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10} />
              <Grid.Column width={6}><Input name='min_fpc_n' formEntry={equipment} label='Minutes' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signaux sonores et visuels programmés et fonctionnant conformément à la conception et aux spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement d'alarme et de surveillance du circuit d'entrée, y compris l'indicateur visuel</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement du signal de défectuosité du circuit d'entrée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_q' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement de l'alarme du circuit de sortie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_r' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement du signal de défectuosité du circuit de sortie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_s' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Essai d'indicateur visuel (essai de lampe)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_t' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Séquences de signal codé fonctionnant au moins le nombre de fois nécessaire et suivies d'un déclenchement du signal d'alarme approprié</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_u' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Séquence de signal codé non interrompues par une alarme subséquente</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_v' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Circuits du dispositif auxiliaire programmés et fonctionnant conformément à la conception et aux spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_w' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement du circuit d'entrée vers le circuit de sortie, y compris les circuits des dispositifs auxiliaires, pour assurer le bon fonctinonement de la matrice, selon la conception et les spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_x' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement du réarmement</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_y' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Commutation de l'alimentation principale à l'alimentation de secours</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_z' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Poste de contrôle à la masse</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_aa' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Le répondeur dessert le même secteur pour les circuits d'entrée que pour les circuits de sortie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_bb' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement en mode autonome du répondeur conformément à la conception et aux spécifications</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_cc' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Vérification de la fonction de confirmation du changement d'état (détecteurs de fumée seulement)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_dd' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Interconnexion du poste de contrôle au poste de surveillance</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_fpc_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_fpc_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_fpc_ee' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>ESSAI DE COMMUNICATION PHONIQUE</Header>)} equipment={equipment} label='ecp_so'>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateur visuel de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité visuel commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité sonore commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Interrupteur de signalisation sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Recherche phonique générale de personnes, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Circuits de sortie en cas de recherche phonique sélective de personnes, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Circuits de sortie pour défectuosité de recherche phonique sélective de personnes, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Microphone, y compris le bouton de communication</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement de la recherche de personnes ne nuisant pas à la temporisation initiale de désactivation de la signalisation sonore d'alerte et d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement de la recherche générale de personnes (en alimentation de secours)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Passage automatique à un amplificateur de relève en cas de panne d'un amplificateur normal</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Circuits de réception d'appel d'un téléphone d'urgence, y compris les indications sonores et visuelles</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Circuits des téléphones d'urgence, y compris les communications phoniques bidirectionnelles</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Circuits de signalisation de défectuosité des téléphones d'urgence, y compris l'indication visuelle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Communication verbale par téléphone d'urgence</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Tonalité d'utilisation ou de disponibilité des téléphones d'urgence au combiné</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ecp_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ecp_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ecp_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>INSPECTION DU POSTE DE CONTRÔLE</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Désignation du circuit d'entrée correctement repérées et correspondant à celles des dispositifs raccordées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Désignations du circuit de sortie correctement répérées et correspondant à celles des dispositifs raccordées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Désignations des fonctions de contrôle communes et des indicateurs communs</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Armoires, composants enfichables et modules solidement en place</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Câbles enfichables solidement en place</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Date, révisions et versions des microprogrammes et des logiciels consignées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10} />
              <Grid.Column width={6}>
                <Input name='date_ipc_f' formEntry={equipment} label='Date' />
                <Input name='rev_ipc_f' formEntry={equipment} label='Révision' />
                <Input name='vers_ipc_f' formEntry={equipment} label='Version' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Propreté</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fusibles conformes aux spécifications des fabricants</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Verrouillage du poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Solidité des connexions du câblage aux dispositifs</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Débranchement de l'alimentation du poste de contrôle conforme au code canadien de l'électricité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Câblage principal d'alimetnatino électrique conforme aux spécifications du fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ipc_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ipc_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ipc_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>INSPECTION DE L'ALIMENTATION</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Conforme à la norme CAN/ULC-S524 et au code canadien de l'électricité, première partie, section 32</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Protection fusible correspondant aux caractéristiques nominales affichées par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Pourvu d'un moyen distinct de débranchement</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Alimentation suffisante puor les besoins du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Dispositifs auxiliaires alimentées par une source distincte de l'alimentation du poste de contrôle du réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Dispositifs auxiliaires alimentés par le poste de contrôle du réseau avertisseur d'incendie, qui est conçu pour fournir cette énergie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>On a noté quels dispositifs auxiliaires sont alimentés par le poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ia_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ia_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ia_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE A L'ESSAI ET INSPECTION DE L'ALIMENTATION DE SECOURS</Header>)} name='batt_ias' equipment={equipment} label='Aucune batterie reliée à une génératrice'>
          <Header as='h5'>BATTERIE 1</Header>
          <Checkbox name='batt1_ias_fonction' formEntry={equipment} label='Fonction' />
          <Checkbox name='batt1_ias_fonction' formEntry={equipment} label='Ampérage / heure nomilal' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Type recommandé par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Caractéristiques nominales suffisantes d'après des calculs fondés sur la pleine charge du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Tension, réseau raccordé à l'alimentation principale</Grid.Column>
              <Grid.Column width={6}><Input name='vcc_batt1_ias_c' formEntry={equipment} label='Vcc' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Courant de charge</Grid.Column>
              <Grid.Column width={6}><Input name='a_batt1_ias_d' formEntry={equipment} label='A' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Tension et courant, alimentation principale coupées et réseau avertisseur d'incendie en mode surveillance</Grid.Column>
              <Grid.Column width={6}><Input name='vcc_batt1_ias_e' formEntry={equipment} label='Vcc' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Courant de charge</Grid.Column>
              <Grid.Column width={6}><Input name='a_batt1_ias_f' formEntry={equipment} label='A' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Recherche de dommages matériels</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Bornes nettoyés et lubrifiées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Bornes serrées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Niveau d'électrolyte correct</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Densité de l'électrolyte conforme aux spécifications du fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Aucune fuite d'électrolyte</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Ventilation adéquate</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Respecte la durée de vie prévue par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Débranchement provoque signal de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>À pleine charge, peut fournir la puissance requise pour la durée requise</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt1_ias_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt1_ias_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt1_ias_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider />
          <Header as='h5'>BATTERIE 2</Header>
          <Checkbox name='batt2_ias_fonction' formEntry={equipment} label='Fonction' />
          <Checkbox name='batt2_ias_fonction' formEntry={equipment} label='Ampérage / heure nomilal' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Type recommandé par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Caractéristiques nominales suffisantes d'après des calculs fondés sur la pleine charge du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Tension, réseau raccordé à l'alimentation principale</Grid.Column>
              <Grid.Column width={6}><Input name='vcc_batt2_ias_c' formEntry={equipment} label='Vcc' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Courant de charge</Grid.Column>
              <Grid.Column width={6}><Input name='a_batt2_ias_d' formEntry={equipment} label='A' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Tension et courant, alimentation principale coupées et réseau avertisseur d'incendie en mode surveillance</Grid.Column>
              <Grid.Column width={6}><Input name='vcc_batt2_ias_e' formEntry={equipment} label='Vcc' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Courant de charge</Grid.Column>
              <Grid.Column width={6}><Input name='a_batt2_ias_f' formEntry={equipment} label='A' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Recherche de dommages matériels</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Bornes nettoyés et lubrifiées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Bornes serrées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Niveau d'électrolyte correct</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Densité de l'électrolyte conforme aux spécifications du fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Aucune fuite d'électrolyte</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Ventilation adéquate</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Respecte la durée de vie prévue par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Débranchement provoque signal de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>À pleine charge, peut fournir la puissance requise pour la durée requise</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_batt2_ias_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_batt2_ias_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_batt2_ias_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI ET INSPECTION DE L'ANNONCIATEUR</Header>)} name='eia_so' equipment={equipment}>
          <Header as='h5'>ANNONCIATEUR 1</Header>
          <Input name='ann1_eia_emplacement' formEntry={equipment} label='Emplacement' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateur de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indication de zone individuelle d'alarme et de surveillance</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Étiquettes de désignation des zones individuelles d'alarme et de surveillance</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Essai d'indicateur visuel (essai de lampe)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Surveillance du câblage d'entrée du poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateur visuel de l'interruption du signal sonore d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Contacts des fonctions auxiliaires fonctionnant comme prévu</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateurs visuels des fonctions auxiliaires</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Actionnement manuel du signal d'alarme et indication</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Affichages visibles dans le lieu de l'installation</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann1_eia_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann1_eia_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann1_eia_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider />
          <Header as='h5'>ANNONCIATEUR 2</Header>
          <Input name='ann2_eia_emplacement' formEntry={equipment} label='Emplacement' />
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateur de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indication de zone individuelle d'alarme et de surveillance</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Étiquettes de désignation des zones individuelles d'alarme et de surveillance</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal de défectuosité commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Essai d'indicateur visuel (essai de lampe)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Surveillance du câblage d'entrée du poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateur visuel de l'interruption du signal sonore d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Contacts des fonctions auxiliaires fonctionnant comme prévu</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indicateurs visuels des fonctions auxiliaires</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Actionnement manuel du signal d'alarme et indication</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Affichages visibles dans le lieu de l'installation</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_ann2_eia_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_ann2_eia_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_ann2_eia_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI ET INSPECTION DE L'AFFICHAGE SÉQUENTIEL</Header>)} name='eia_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Entrée individuelles d'alarme, de surveillance et de défectuosité indiquées clairement, de manière distincte</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Etiquette de désignation des entrées individuelles d'alarme et de surveillance correctement marquées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Priorité d'un signal d'entrée d'alarme sur les signaux d'entrée de surveillance et de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Priorité d'un signal d'entrée de surveillance sur le signal d'entrée de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Possibilité de sélection manuelle de l'affichage</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Affichage continu de la première alarme jusqu'à ce qu'une sélection manuelle différente soit effectuée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Première alarme clairement identifiée chaque fois qu'elle est affichée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Possibilité de récupération des entrées de signaux d'alarme et de surveillance tant que le réseau n'a pas été réarmé</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Liaison de données conrrectement installée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement sur alimentation de secours pendant la durée requise</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Un dispositif manuel d'avancement de l'affichage des alarmes</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Un dispositif manuel d'avancement de l'affichage de la surveillance</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Un dispositif manuel d'avancement de l'affichage des défectuosités</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Dispositifs d'avancement de l'affichage ouvert et accessible en tout temps</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Dispositif d'avancement de l'affichage qui ne gêne pas le fonctionnement du poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Avancement manuel des alarmes par ordre d'occurrence</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Dispositif d'avance de l'affichage facile à reconnaître</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_q' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Indication visuelle si plusieurs signaux d'entrée simultanés (alarme et/ou surveillance) existent simultanément</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_r' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signaux d'alarme ou de surveillance non intércalés et/ou non affichés simultanément, sauf si les couleurs d'affichage des signaux d'entrée ci-dessous sont utilisées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_s' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>alarme: rouge</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_t' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Surveillance: jaune (ambré)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_u' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Défectuosité: jaune</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_v' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Alimentation: vert</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_w' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Affichage de l'état de tous les signaux de sortie pouvant être controlés manuellement, selon les besoins</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_x' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Court-circuit, circuit ouvert ou fuite à la terre sur prolongement de circuit du dispositif d'affichage (ne faisant pas partie de l'affichage requis au poste de contrôle) ne gênant pas le fonctionnement du poste de contrôle.</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iaseq_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iaseq_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iaseq_y' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE A L'ESSAI ET INSPECTION À DISTANCE DE L'UNITÉ DÉFECTUEUSE</Header>)} name='idud_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Surveillance du câblage d'entrée du poste de contrôle</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_idud_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_idud_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_idud_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal visuel de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_idud_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_idud_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_idud_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Signal sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_idud_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_idud_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_idud_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Interruption du signal sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_idud_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_idud_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_idud_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE A L'ESSAI DE L'IMPRIMANTE</Header>)} name='mei_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement normal</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mei_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mei_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mei_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Impression correcte de la zone de chaque dispositif de déclenchement d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_mei_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_mei_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_mei_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI ET INSPECTION DES IMPRIMANTES DANS UN CENTRE DE CONTRÔLE PRIVÉ</Header>)} name='iiccp_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Impression automatique des évènements et des acquittements</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Impression de l'heure et de la date de chaque évèvement</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Enregistrement de chaque évènement au moment où il se produit, sans égard au moment où il est acquitté</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Enregistrement par le système des changements d'état sans aucune perte de données</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Avance automatique du papier de façon à produire un document lisible</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fonctionnement de l'imprimante alors que l'alimentation principale est en panne</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Surveillance de l'imprimante avec indication en cas de réserve de papier basse ou épuisée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_iiccp_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_iiccp_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_iiccp_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>MISE À L'ESSAI DES FONCTIONS AUXILIAIRES</Header>)} name='efa_so' equipment={equipment}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={10}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>S.O.</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Arrêt de la ventilation</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Rappel des ascenseurs au rez-de-chaussée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Rappel des ascenseurs à un palier alternatif</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Fermeture des portes coupe-feu (retenue de porte)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Déverrouillage des portes d'issues (électro-aimant)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Pressurisation de la cage d'escaliers</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Pressurisation de la cage d'ascenseur</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>Arrêt de système de balayeuse centrale</Grid.Column>
              <Grid.Column width={2}><Checkbox name='yes_efa_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='no_efa_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='so_efa_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider />
          <TextArea name='so_efa_other' formEntry={equipment} label='Autre(s) dispositif(s)… (précisez)' rows={3} />
        </Section>
        <Section title={(<Header as='h2'>DÉFICIENCES MAJEURES (SECTION #1)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d1' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D1</strong></Table.Cell>
                <Table.Cell>Équipement défectueux</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d2' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D2</strong></Table.Cell>
                <Table.Cell>Équipement défectueux à cause d'un problème de filage</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d3' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D3</strong></Table.Cell>
                <Table.Cell>Équipement endommagé</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d4' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D4</strong></Table.Cell>
                <Table.Cell>Les batteries sont trop faibles pour alimenter le réseau pendant la période requise</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d5' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D5</strong></Table.Cell>
                <Table.Cell>Étiquette de désignation erronée et/ou imprécise</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d6' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D6</strong></Table.Cell>
                <Table.Cell>Équipement peinturé</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d7' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D7</strong></Table.Cell>
                <Table.Cell>Équipement mal fixé</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d8' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D8</strong></Table.Cell>
                <Table.Cell>Le système installé ne répond pas à la définition d'un réseau avertisseur d'incendie (CNB 3.2.4)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d9' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D9</strong></Table.Cell>
                <Table.Cell>La centrale n'a pas reçu de signaux</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d10' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D10</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d10' formEntry={equipment} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>DÉFICIENCES (SECTION #2)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d11' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D11</strong></Table.Cell>
                <Table.Cell>Cet équipement n'est pas installé pour son utilisation optimale (ULC S524)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d12' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D12</strong></Table.Cell>
                <Table.Cell>Le pré-signal excède la période permise (CNB 3.2.4.4)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d13' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D13</strong></Table.Cell>
                <Table.Cell>Le signal d'alarme s'arrête automatiquement avant le délai prévu par le code (CNB 3.2.4.6)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d14' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D14</strong></Table.Cell>
                <Table.Cell>L'activation du microphone arrête la signalisation pendant la première minute (CNB 3.2.4.22)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d15' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D15</strong></Table.Cell>
                <Table.Cell>Cet équipement devrait être relié sur une autre zone (CNB 3.2.4.8)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d16' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D16</strong></Table.Cell>
                <Table.Cell>Cet équipement n'est pas facilement visible et/ou accessible (CNPI 6.3.1.2)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d17' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D17</strong></Table.Cell>
                <Table.Cell>Il y a plusieurs types de sonneries lors d'une alarme incendie (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d18' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D18</strong></Table.Cell>
                <Table.Cell>Détecteur de chaleur requis (CNB 3.2.4.10)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d19' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D19</strong></Table.Cell>
                <Table.Cell>Détecteur de fumée requis (CNB 3.2.4.11)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d20' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D20</strong></Table.Cell>
                <Table.Cell>Station manuelle requise (CNB 3.2.4.17)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d21' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D21</strong></Table.Cell>
                <Table.Cell>Équipement de signalisation sonore requis (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d22' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D22</strong></Table.Cell>
                <Table.Cell>Équipement de signalisation visuel requis (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d23' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D23</strong></Table.Cell>
                <Table.Cell>Ce système doit être relié à une centrale de surveillance (CNB 3.2.4.7)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d24' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D24</strong></Table.Cell>
                <Table.Cell>Il n'y a pas de panneau annonciateur à cette entrée du bâtiment (CNB 3.2.4.8)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d25' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D25</strong></Table.Cell>
                <Table.Cell>Le système de gicleurs n'est pas entièrement sous surveillance électrique (CNB 3.2.4.9)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d26' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D26</strong></Table.Cell>
                <Table.Cell>La signatlisation d'alarme ne s'entend pas adéquatement à cet endroit (CNB 3.2.4.19)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d27' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D27</strong></Table.Cell>
                <Table.Cell>Les portes des issues restent vérouillées lors d'une alarme (CNB 3.4.6.15)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d28' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D28</strong></Table.Cell>
                <Table.Cell>Les portes coupe-feu ne se ferment pas lors d'une alarme (CNB 3.1.8.12)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d29' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D29</strong></Table.Cell>
                <Table.Cell>La hotte de cuisine n'est pas reliée au système (NFPA #96 10.6.2)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d30' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D30</strong></Table.Cell>
                <Table.Cell>Les batteries de secours ne sont pas assez fortes pour la durée requise (CNB 3.2.7.8)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d31' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D31</strong></Table.Cell>
                <Table.Cell>Cette supervision ne se vérouille pas (ULC S-524 5.3.3)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d32' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D32</strong></Table.Cell>
                <Table.Cell>Cette supervision donne un signal identique au bris de fils lors de son activation (ULC-S524 5.3.5)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d33' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D33</strong></Table.Cell>
                <Table.Cell>Le détecteur de gaine n'arrête pas la ventilation (CNB 3.2.4.12)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d34' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D34</strong></Table.Cell>
                <Table.Cell>L'ascenseur demeure en fonction lors d'une alarme (CNB 3.2.4.14)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d35' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D35</strong></Table.Cell>
                <Table.Cell>L'ascenseur n'est pas renvoyé sur un palier alternatif (CNB 3.2.4.14)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d36' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D36</strong></Table.Cell>
                <Table.Cell>Le dispositif de sécurité (tamper) à priorité sur le signal de l'équipement (ULC S-524 5.3.9 et 10)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d37' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D37</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d37' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d38' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D38</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d38' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_deficience_d39' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>D39</strong></Table.Cell>
                <Table.Cell><Input name='text_deficience_d39' formEntry={equipment} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>REMARQUES (SECTION #2)</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r1' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R1</strong></Table.Cell>
                <Table.Cell>Nous avons seulement effectué une vérification aux bornes de raccordement de cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r2' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R2</strong></Table.Cell>
                <Table.Cell>Nous n'avons pas eu accès à ce local</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r3' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R3</strong></Table.Cell>
                <Table.Cell>Cet équipement est inaccessible</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r4' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R4</strong></Table.Cell>
                <Table.Cell>Nous n'avons pas localisé cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r5' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R5</strong></Table.Cell>
                <Table.Cell>Cet équipement n'a pas été mis à l'essai depuis 3 ans ou plus</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r6' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R6</strong></Table.Cell>
                <Table.Cell>Ce détecteur est à déclenchement unique</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r7' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R7</strong></Table.Cell>
                <Table.Cell>Un technicien de gicleur est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r8' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R8</strong></Table.Cell>
                <Table.Cell>Un technicien d'ascenseur est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r9' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R9</strong></Table.Cell>
                <Table.Cell>Un technicien de la génératrice est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r10' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R10</strong></Table.Cell>
                <Table.Cell>Un technicien de système automatique de cuisine est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r11' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R11</strong></Table.Cell>
                <Table.Cell>Un technicien du système d'extinction est requis pour inspecter cet équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r12' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R12</strong></Table.Cell>
                <Table.Cell>Les essais mentionnés aux articles 5,8,4,1,3 n'ont pas été effectués</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r13' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R13</strong></Table.Cell>
                <Table.Cell>La sensibilité indiquée dans la colonne ''note'' est cette founi par le panneau</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r14' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R14</strong></Table.Cell>
                <Table.Cell>L'analyseur de batterie est inférieur à 70%, mais supérieur à 60%, il faudra prévoir leurs remplacements lors de la prochaine inspection</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r15' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R15</strong></Table.Cell>
                <Table.Cell>La résistance de F.D.L. est installée dans l'équipement</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r16' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R16</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r16' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r17' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R17</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r17' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r18' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R18</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r18' formEntry={equipment} /></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Checkbox name='check_remarque_r19' formEntry={equipment} /></Table.Cell>
                <Table.Cell><strong>R19</strong></Table.Cell>
                <Table.Cell><Input name='text_remarque_r19' formEntry={equipment} /></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>REMARQUES INTERNES AUX TECHNICIENS ET/OU BUREAU</Header>)}>
          <Table celled compact='very' size='small' style={{ minWidth: '800px!important' }}>
            <Table.Body>
              {[...Array(32)].map((row, index) => (
                <Table.Row key={`tableRowExL${index + 1}`}>
                  <Table.Cell><Input name={`text_remarqueInterne_${index + 1}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
      </Form>
    )
  }
}

export default RIA537000P
